import React from 'react';

import { Icon } from 'apps/auth/components/common/Icon/Icon';

import { Container, IconWrapper, MenuLink, NavigationMenuText, Notification } from './styles';

interface MenuItemProps {
    isSelected: boolean;
    link: string;
    title?: string;
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
    testId: string;
    notificationAmount?: number;
    isHidden?: boolean;
    isHiddenMobile?: boolean;
    iconId: string;
}

export const MenuItem: React.FC<MenuItemProps> = (props) => {
    if (props.isHidden) {
        return null;
    }

    return (
        <Container isSelected={props.isSelected} isHiddenMobile={props.isHiddenMobile}>
            <MenuLink href={props.link} data-testid={`menu-side-bar-link-${props.testId}`} onClick={props.onClick}>
                <IconWrapper>
                    <Icon name={props.iconId} color={props.isSelected ? 'primary' : 'secondary'} />
                    {props.notificationAmount && props.notificationAmount !== 0 && <Notification>{props.notificationAmount}</Notification>}
                </IconWrapper>
                <NavigationMenuText>{props.title}</NavigationMenuText>
            </MenuLink>
        </Container>
    );
};
